import Model from '../../ModelBinding/Model';
import OperatorInvoiceCollection from './OperatorInvoiceCollection';
import dayjs from 'dayjs';
import OrderCollection from '../Order/OrderCollection';
import OrderLineItemCollection from '../OrderLineItem/OrderLineItemCollection';
import Organization from '../Organization/Organization';
import StateCollection from '../State/StateCollection';
import OperatorInvoiceDocumentCollection from '../OperatorInvoiceDocument/OperatorInvoiceDocumentCollection';
import OperatorInvoiceEventCollection from '../OperatorInvoiceEvent/OperatorInvoiceEventCollection';
import AgessaRateCollection from '../AgessaRate/AgessaRateCollection';
import OperatorsPaymentCollection from '../OperatorPayment/OperatorsPaymentCollection';
import OperatorsPayment from '../OperatorPayment/OperatorsPayment';
import Member from '../Member/Member';
export default class OperatorInvoice extends Model {
  public due_date?: dayjs.Dayjs;
  public payment_date?: dayjs.Dayjs;
  public quote_date?: dayjs.Dayjs;
  public invoice_date?: dayjs.Dayjs;
  public number?:string;
  public paid?:boolean;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public orders?: OrderCollection;
  public total_agessa?: number;
  public total_amount?: number;
  public total_vat?:number;
  public total_amount_excl_vat?:number;
  public current_status?:string;
  public order_items?: OrderLineItemCollection;
  public organization?: Organization;
  public states?: StateCollection;
  public operator_invoice_documents?: OperatorInvoiceDocumentCollection;
  public events?: OperatorInvoiceEventCollection;
  public agessa_rates?:AgessaRateCollection;
  public agessa_rates_contributions?:AgessaRateCollection;
  public agessa_rates_preaccount?:AgessaRateCollection;
  public total_agessa_contributions?: number;
  public total_agessa_preaccount?: number;
  public total_to_pay?: number;
  public vat_percent?: number;
  public operator_payments?: OperatorsPaymentCollection;
  public country?: string;
  public currency?: string;
  public last_payment?:OperatorsPayment;
  public operator?: Member;

  bind() {
    this.due_date = this.getDateAttribute('due_date');
    this.payment_date = this.getDateAttribute('payment_date');
    this.quote_date = this.getDateAttribute('quote_date');
    this.invoice_date = this.getDateAttribute('invoice_date');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.number = this.getStringAttribute('number');
    this.paid = this.getBooleanAttribute('paid');
    this.country = this.getStringAttribute('country');
    this.currency = this.getStringAttribute('currency');
    this.total_agessa = this.getFloatAttribute('total_agessa');
    this.total_agessa_contributions = this.getFloatAttribute('total_agessa_contributions');
    this.total_agessa_preaccount = this.getFloatAttribute('total_agessa_preaccount');
    this.total_amount = this.getFloatAttribute('total_amount');
    this.total_amount_excl_vat = this.getFloatAttribute('total_amount_excl_vat');
    this.total_vat = this.getFloatAttribute('total_vat');
    this.total_to_pay = this.getFloatAttribute('total_to_pay');
    this.vat_percent = this.getFloatAttribute('vat_percent');
    this.current_status = this.getStringAttribute('current_status');
    this.orders = this.getRelationAttributeCollection('orders', OrderCollection) as OrderCollection;
    this.order_items = this.getRelationCollection('order_items', OrderLineItemCollection) as OrderLineItemCollection;
    this.organization = this.getRelation('organization', Organization) as Organization;
    this.last_payment = this.getRelation('last_payment', OperatorsPayment) as OperatorsPayment;
    this.operator = this.getOriginalAttribute('operator', Member) as Member;
    this.states = this.getRelationCollection(
      'states',
      StateCollection,
    ) as StateCollection;
    this.operator_invoice_documents = this.getRelationCollection(
      'operator_invoice_documents',
      OperatorInvoiceDocumentCollection,
    ) as OperatorInvoiceDocumentCollection;
    this.events = this.getRelationCollection(
      'events',
      OperatorInvoiceEventCollection,
    ) as OperatorInvoiceEventCollection;
    this.agessa_rates = this.getRelationCollection(
      'agessa_rates',
      AgessaRateCollection,
    ) as AgessaRateCollection;
    this.agessa_rates_contributions = this.getRelationCollection(
      'agessa_rates_contributions',
      AgessaRateCollection,
    ) as AgessaRateCollection;
    this.agessa_rates_preaccount = this.getRelationCollection(
      'agessa_rates_preaccount',
      AgessaRateCollection,
    ) as AgessaRateCollection;
    this.operator_payments = this.getRelationCollection(
      'operator_payments',
      OperatorsPaymentCollection,
    ) as OperatorsPaymentCollection;
  }

  static getCollection() {
    return OperatorInvoiceCollection;
  }
}
